import { api } from './api';

export type Theme = 'light' | 'dark' | 'system';

export interface UserPreferences {
  theme: Theme;
}

export const preferencesService = {
  async get(): Promise<UserPreferences> {
    const { data } = await api.get<UserPreferences>('/me/preferences');
    return data;
  },

  async update(patch: Partial<UserPreferences>): Promise<UserPreferences> {
    const { data } = await api.patch<UserPreferences>('/me/preferences', patch);
    return data;
  },
};
